import React, { useMemo } from "react";
import { useNativePlatform } from "@/hooks/useNativePlatform";
import Footer from "@/components/Footer";
import SEOHead from "@/components/SEOHead";
import LandingHeader from "@/components/landing/LandingHeader";
import {
  HeroSection,
  HowItWorksSection,
  WellnessSection,
  TherapistSection,
  PartnershipsSection,
  FinalCTA,
} from "@/components/landing/StorySections";
import InstagramCarousel from "@/components/landing/InstagramCarousel";
import StoreSection from "@/components/landing/StoreSection";
import FromVentSection from "@/components/landing/FromVentSection";
import promoVideo from "@/assets/vent-promo-video.mp4.asset.json";

const Index = () => {
  const isNative = useNativePlatform();
  const showStoreLinks = !isNative;

  const jsonLd = useMemo(
    () => [
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "Vent",
        url: "https://www.theventapp.com",
        logo: "https://www.theventapp.com/vent-icon.png",
        description:
          "Anonymous peer support and wellness platform for venting, stress relief and mental wellness",
        sameAs: ["https://www.instagram.com/the.vent.app"],
        contactPoint: {
          "@type": "ContactPoint",
          email: "support@theventapp.com",
          contactType: "customer support",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "WebApplication",
        name: "The Vent App",
        url: "https://www.theventapp.com",
        applicationCategory: "HealthApplication",
        operatingSystem: "Web, iOS",
        description:
          "A safe, anonymous space for venting, peer support and everyday wellness tools.",
        offers: { "@type": "Offer", price: "0", priceCurrency: "USD" },
      },
    ],
    []
  );

  return (
    <div className="min-h-screen overflow-x-hidden bg-background">
      <SEOHead
        title="The Vent App | Anonymous Venting & Peer Support"
        description="The Vent App gives you a space to vent anonymously, connect through topic-based peer support, and use journaling, self-care and mental wellness tools."
        canonicalPath="/"
        jsonLd={jsonLd}
      />

      <LandingHeader />

      <main>
        <HeroSection showStoreLinks={showStoreLinks} />
        <HowItWorksSection videoUrl={promoVideo.url} showVideo={!isNative} />
        <WellnessSection />
        <TherapistSection />
        <InstagramCarousel />
        <StoreSection />
        <PartnershipsSection />
        <FinalCTA showStoreLinks={showStoreLinks} />
        <FromVentSection />
      </main>

      <Footer />
    </div>
  );
};

export default Index;
